<app-header></app-header>

<section>
  <div class="container"  #scrollContainer>    
      <div class="text-center">
        <div class="forgotdiv">
          <h1>Preview Details before Submission</h1>
          <hr>
          <div class="card mb-3">
            <div class="card-header"><h2 class="text-start">Personal Details</h2></div>
            <div class="card-body">
              <div class="row text-start">
                <div class="col-md-4">
                  <label>UDYAM Number</label>
                  <input type="text" id="txtudyamnumber" name="udyamnumber" [value]="PersonalPreviewData?.udyamRegistrationNumber" disabled class="form-control">
                </div>
                <div class="col-md-4">
                  <label>Name</label>
                  <input type="text" id="txtname" name="name" [value]="PersonalPreviewData?.name" disabled class="form-control">
                </div>
                <div class="col-md-4">
                  <label>Gender</label>
                  <input type="text" id="txtgender" name="gender" [value]="PersonalPreviewData?.gender" disabled class="form-control">
                </div>
              </div>
              <div class="row text-start">
                <div class="col-md-4">
                  <label>Email</label>
                  <input type="text" id="txtemail" name="email" [value]="PersonalPreviewData?.email" disabled class="form-control">
                </div>
                <div class="col-md-4">
                  <label>Owner's Mobile Number</label>
                  <input type="text" id="txtownersmobnum" name="ownersmobnum" [value]="PersonalPreviewData?.ownersMobileNumber" disabled class="form-control">
                  <label for="chkboxwhatsappenabled">Is Whatsapp Number ?</label>{{PersonalPreviewData?.isWhatsAppEnabled?'Yes':'No'}}
                  <!--<input type="checkbox" id="chkboxwhatsappenabled" name="whatsappenabled"
          [checked]="PersonalPreviewData?.IsWhatsAppEnabled" disabled />-->
                </div>
                <div class="col-md-4">
                  <label>Are you persons with Disabilities?</label><br />
                  {{ PersonalPreviewData?.areYouAPersonWithDisabilities ? 'Yes' : 'No' }}
                </div>
              </div>

              <div class="row text-start">
                <div class="col-md-4">
                  <label>Social Category</label>
                  <input type="text" id="txtsocialcategory" name="socialcategory" [value]="PersonalPreviewData?.SelectedSocialCategory" disabled class="form-control">
                </div>
                <div class="col-md-4">
                  <label>Alternate Mobile Number</label>
                  <input type="text" id="txtalternatemobilenumber" name="alternatemobnum" [value]="PersonalPreviewData?.alternateContactNumber ? PersonalPreviewData.alternateContactNumber : 'NA'" disabled class="form-control">
                </div>
              </div>
            </div>
          </div>

          <div class="card mb-3">
            <div class="card-header"> <h2 class="text-start">Enterprise Details</h2></div>
            <div class="card-body">
              <div class="row text-start">
                <div class="col-md-4">
                  <label>Name of Enterprise</label>
                  <input type="text" id="txtnameOfEnterprise" name="nameOfEnterprise" [value]="PersonalPreviewData?.nameOfEnterprise" disabled class="form-control">
                </div>
                <div class="col-md-4">
                  <label>Type of Enterprise</label>
                  <input type="text" id="txttypeOfEnterprise" name="typeOfEnterprise" [value]="PersonalPreviewData?.SelectedEnterpriseType" disabled class="form-control">
                </div>
                <div class="col-md-4">
                  <label>Type of Organization</label>
                  <input type="text" id="txttypeOfOrganization" name="typeOfOrganization" [value]="PersonalPreviewData?.SelectedOrganizationType" disabled class="form-control">
                </div>
              </div>

              <div class="row text-start">
                <div class="col-md-4">
                  <label>Official Address of Enterprise</label>
                  <!--<input type="text" id="txtentaddress" name="entaddress" [value]="PersonalPreviewData?.officialAddressOfEnterprise" disabled class="form-control">-->
                  <textarea id="txtentaddress" name="entaddress" [value]="PersonalPreviewData?.officialAddressOfEnterprise" disabled class="form-control"></textarea>

                </div>
                <div class="col-md-4">
                  <label>State</label>
                  <input type="text" id="txtstate" name="state" [value]="PersonalPreviewData?.SelectedState" disabled class="form-control">
                </div>
                <div class="col-md-4">
                  <label>District</label>
                  <input type="text" id="txtdistrict" name="district" [value]="PersonalPreviewData?.SelectedDistrict" disabled class="form-control">
                </div>
              </div>

              <div class="row text-start">
                <div class="col-md-4">
                  <label>Block</label>
                  <input type="text" id="txtblock" name="block" [value]="PersonalPreviewData?.SelectedBlock ? PersonalPreviewData.SelectedBlock  : 'NA'" disabled class="form-control">
                </div>
                <div class="col-md-4">
                  <label>City</label>
                  <input type="text" id="txtcity" name="city" [value]="PersonalPreviewData?.city" disabled class="form-control">
                </div>
                <div class="col-md-4">
                  <label>Pincode</label>
                  <input type="text" id="txtpin" name="pin" [value]="PersonalPreviewData?.pin" disabled class="form-control">
                </div>
              </div>
              <div class="row text-start">
                <div class="col-md-4">
                  <label>DIC</label>
                  <input type="text" id="txtdic" name="dic" [value]="PersonalPreviewData?.dic" disabled class="form-control">                  
                </div>                
              </div>

              <div class="row text-start">
                <div class="row text-start">
                  <div class="col-md-4">
                    <label>Date of Incorporation</label>
                    <input type="text" id="txtdateofIncorporation" name="dateofIncorporation" [value]="PersonalPreviewData?.dateOfIncorporation ? PersonalPreviewData.dateOfIncorporation : 'NA'" disabled class="form-control">
                  </div>
                  <div class="col-md-4">
                    <label>Date of Commencement</label>
                    <input type="text" id="txtdateOfCommencement" name="dateOfCommencement" [value]="PersonalPreviewData?.dateOfCommencement ? PersonalPreviewData.dateOfCommencement :'NA' " disabled class="form-control">
                  </div>
                  <div class="col-md-4">
                    <label>Major Activity</label>
                    <input type="text" id="txtmajoractivity" name="majoractivity" [value]="PersonalPreviewData?.majorActivity ? PersonalPreviewData.majorActivity : 'NA'" disabled class="form-control">
                  </div>
                </div>
              </div>
              <div class="row text-start">
                <div class="col-md-4">
                  <label>Investment Cost</label>
                  <input type="text" id="txtinvestmentcost" name="investmentcost" [value]="PersonalPreviewData?.investmentCost ? PersonalPreviewData.investmentCost :'NA'" disabled class="form-control">
                </div>
              </div>
              <!--<div class="row text-start">
  <div class="col-md-4">
    <label>Are you an Exporter ?</label><br />
    {{PersonalPreviewData?.areYouAnExporter? 'Yes':'No'}}-->
              <!--<input type="checkbox" id="chkboxexporter" name="areyouanexporter"
  [checked]="PersonalPreviewData?.AreYouAnExporter" disabled />-->
              <!--</div>
    <div class="col-md-4">
      <label>IEC</label>
      <input type="text" id="txtiec" name="iec" [value]="PersonalPreviewData?.iec ? PersonalPreviewData.iec : 'NA'" disabled class="form-control">
    </div>
  </div>-->
            </div>
          </div>

          <div class="card mb-3">
            <div class="card-header"> <h2 class="text-start">NIC Details</h2></div>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-striped table-bordered table-hover">
                  <thead>
                    <tr>
                      <th class="text-center">NIC Code</th>
                      <th class="text-center">Sector</th>
                      <th class="text-center">Divison</th>
                      <th class="text-center">Group</th>
                      <th class="text-center">Class</th>
                      <th class="text-center">Sub Class</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let unit of PersonalPreviewData.msmeUserNICCodeDetails">
                      <td class="text-center">{{ unit.nicCode }}</td>
                      <td class="text-center">{{ unit.sector }}</td>
                      <td class="text-center">{{ unit.divisionDescription }}</td>
                      <td class="text-center">{{ unit.groupDescription }}</td>
                      <td class="text-center">{{ unit.class }}</td>
                      <td class="text-center">{{ unit.subClass }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="card mb-3">
            <div class="card-header"> <h2 class="text-start">Plant and Location Details</h2></div>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-striped table-bordered table-hover">
                  <thead>
                    <tr>
                      <th class="text-center">Plant Unit</th>
                      <th class="text-center">Location</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngIf="PersonalPreviewData.msmeUserPlantUnitDetails && PersonalPreviewData.msmeUserPlantUnitDetails.length > 0; else noPlantData">
                      <tr *ngFor="let unit of PersonalPreviewData.msmeUserPlantUnitDetails">
                        <td class="text-center">{{ unit.name }}</td>
                        <td class="text-center">{{ unit.location }}</td>
                      </tr>
                    </ng-container>
                    <ng-template #noPlantData>
                      <tr>
                        <td colspan="9" class="text-center">N/A</td>
                      </tr>
                    </ng-template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="card mb-3">
            <div class="card-header"> <h2 class="text-start">Interests</h2></div>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-striped table-bordered table-hover">
                  <thead>
                    <tr>
                      <th class="text-center">Interest</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let unit of PersonalPreviewData.msmeUserInterests">
                      <td class="text-center">{{ unit.interestName }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              
            </div>
          </div>
        
          <div class="row text-start" *ngIf="PersonalPreviewData?.udyamCertificateFile">
            <div class="col-md-4">
              <h2 class="text-start">Uploaded Udyam Certificate:</h2>
            </div>         
            <table class="table table-striped table-bordered table-hover">
              <thead>
                <tr>
                  <th class="text-center">File Name</th>
                  <th class="text-center">Download Link</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-center">Udyam Certificate</td>
                  <td class="text-center">
                    <a [href]="certificateLink" target="_blank" download="{{ PersonalPreviewData.udyamCertificateFile.name }}">{{ PersonalPreviewData.udyamCertificateFile.name }}</a>
                   
                  </td>
                </tr>
              </tbody>
            </table>

          </div>
          <br />
          <h2 class="text-start" *ngIf="documents && documents.length > 0">Other Documents Uploaded</h2>

          <div *ngIf="documents && documents.length > 0" class="table-responsive">
            <table class="table table-striped table-bordered table-hover">
              <thead>
                <tr>
                  <th class="text-center">Sr. No.</th>
                  <th class="text-center">File Name</th>
                  <th class="text-center">Download Link</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let doc of documents; let i = index">
                  <td class="text-center">{{ i + 1 }}</td>
                  <td class="text-center">{{ doc.name || 'No name available' }}</td>
                  <td class="text-center">
                    <a *ngIf="documentLinks[i]" [href]="documentLinks[i]" target="_blank" download="{{ doc.name }}">
                      {{ doc.name }}
                    </a>
                    <span *ngIf="!documentLinks[i]">No file available</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <hr />

          <form [formGroup]="previewForm" #form="ngForm">
            <div class="row text-start mb-3">
              <h2>
                <b>
                  Declaration :
                </b>
              </h2>
              <label>
                <input type="checkbox"
                       formControlName="termsConditionAccepted" />
                The information I/ we have furnished/ will furnish at various stages of engagement with MSSIDC, Government of Maharashtra, Government of India and The World Bank is correct to the best of my/ our knowledge. I/ we understand that any willful misstatement described herein may lead to my/ our organization's disqualification as Implementation Agency under the Programme.
              </label>
            </div>

            <div class="row text-start mb-3">
              <h2><b>Third Party Data usage undertaking : </b></h2>
              <label>
                <input type="checkbox"
                       formControlName="thirdPartyUndertaking" />
                I/ we understand that any data provided to us by MSSIDC in relation to the RAMP Programme is strictly for the purpose of authorized implementation of the programme components. I/ we understand that we do not have the authority to share this data with any other person unless so authorized by MSSIDC.
              </label>
            </div>
            <div class="text-start mb-3">
              <label for="captcha">Please enter the text below:</label>
              <div>
                <canvas id="captchaCanvas" width="150" height="50"></canvas>
              </div>
              <div class="row">
                <div class="col-md-3 col-xs-12"><input type="text" placeholder="Enter CAPTCHA" formControlName="captcha" class="form-control pull-left" maxlength="6"/></div>
                <div class="col-md-6 col-xs-12"><button (click)="generateCaptcha()" class="btn btn-primary btn-sm mt-1">Refresh Captcha</button></div>
              </div>
            </div>
            <p *ngIf="captchaError" style="color: red;">Invalid CAPTCHA!</p>
            <p *ngIf="captchaSuccess" style="color: green;">CAPTCHA verified successfully</p>

          </form>

          <button id="btnSave" type="button" (click)="SaveMSMEUser()" class="btn btn-success">Save</button>
          <button (click)="navigateBack()" class="btn btn-info">Back</button>
          <button id="btnCancel" type="button" (click)="gotoUdyamVerify()" class="btn btn-danger">Cancel</button>
        </div>
      </div>
    
  </div>
</section>
<app-footer></app-footer>
